<template>
  <div>
    <div class="Kanit text-center pt-6 pb-5">
      <h3 style="color: #0c4d9d">กรอกข้อมูลแจ้งเริ่มงาน</h3>
    </div>
    <div>
      <v-container class="Kanit" style="padding-bottom: 50px">
        <div style="text-align: center; position: relative" class="py-2 mb-3">
          <div
            v-if="$store.state.redirect"
            style="position: absolute; top: 0px; left: 0px"
          >
            <v-btn
              @click="query.view = $store.state.redirect"
              text
              class="pl-0"
            >
              <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
            </v-btn>
          </div>
          <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        </div>
        <ValidationObserver ref="observer" tag="form">
          <form>
            <ValidationProvider
              v-slot="{ errors }"
              name="ชื่อผู้จ้าง"
              key="name"
            >
              <v-text-field
                outlined
                :error-messages="errors"
                class="mb-7"
                name="name"
                placeholder="กรอกชื่อผู้จ้าง"
                disabled
                hide-details
                @input="input.customer_name = removeHiddenSpace($event)"
                v-model="input.customer_name"
                style="
                  border-radius: 12px;
                  background-color: rgba(0, 0, 0, 0.06);
                "
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    ผู้จ้าง
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
            <v-menu
              ref="menu1"
              v-model="menustartdate"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="เริ่มงาน"
                  rules="required"
                  key="startdate"
                >
                  <v-text-field
                    outlined
                    :error-messages="errors"
                    v-on="on"
                    name="startdate"
                    placeholder="กรอกเริ่มงาน"
                    :value="
                      input.startdate
                        ? moment(input.startdate)
                            .locale('TH')
                            .format('DD MMMM YYYY')
                        : ''
                    "
                    style="border-radius: 12px"
                  >
                    <template v-slot:label>
                      <div style="color: rgb(0 112 250); font-weight: 900">
                        เริ่มงาน
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
              <v-date-picker
                locale="th"
                v-model="input.startdate"
                no-title
                @input="menustartdate = false"
              ></v-date-picker>
            </v-menu>
            <ValidationProvider
              v-slot="{ errors }"
              name="เวลาทำงาน"
              rules="required"
              key="time"
            >
              <v-text-field
                outlined
                name="time"
                placeholder="กรอกระยะเวลาทำงาน"
                :error-messages="errors"
                v-model="input.worktime"
                style="border-radius: 12px"
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    เวลาทำงาน
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="พื้นที่ทาสี"
              key="area"
            >
              <v-text-field
                outlined
                name="area"
                placeholder="กรอกพื้นที่การทาสี"
                :error-messages="errors"
                v-model="input.paintarea"
                style="border-radius: 12px"
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    พื้นที่ทาสี
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="ประเภทงาน"
              rules="required"
              key="worktype"
            >
              <v-text-field
                outlined
                :error-messages="errors"
                name="worktype"
                hide-details
                class="mb-7"
                disabled
                placeholder="กรอกประเภทงาน"
                v-model="input.work_type"
                style="
                  border-radius: 12px;
                  background-color: rgba(0, 0, 0, 0.06);
                "
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    ประเภทงาน
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider
              v-slot="{ errors }"
              name="ราคา"
              rules="required"
              key="price"
            >
              <v-text-field
                outlined
                type="number"
                :error-messages="errors"
                name="price"
                placeholder="กรอกราคา"
                v-model="input.price"
                style="border-radius: 12px"
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    ราคา
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="สถานที่ปฏิบัติงาน"
              rules="required"
              key="workplace"
            >
              <v-textarea
                outlined
                name="workplace"
                :error-messages="errors"
                rows="4"
                class="mb-7"
                hide-details
                disabled
                placeholder="กรอกสถานที่ปฏิบัติงาน"
                v-model="input.work_address"
                style="
                  border-radius: 12px;
                  background-color: rgba(0, 0, 0, 0.06);
                "
              >
                <template v-slot:label>
                  <div style="color: rgb(0 112 250); font-weight: 900">
                    สถานที่ปฏิบัติงาน
                  </div>
                </template>
              </v-textarea>
            </ValidationProvider>
          </form>
        </ValidationObserver>
        <div @click="confirmData" v-ripple class="addcartbtn Kanit myshadow">
          <p v-if="!saveloading">ยืนยันข้อมูล</p>
          <div v-else>
            <v-progress-circular
              indeterminate
              size="35"
              color="white"
            ></v-progress-circular>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      menustartdate: false,
      input: {
        customer_name: "",
        startdate: "",
        worktime: "",
        paintarea: "",
        work_type: "",
        price: "",
        work_address: "",
      },
      saveloading: false,
      loading: false,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    moment() {
      return moment;
    },
  },
  async mounted() {
    Promise.all([this.toapaintertransaction(), this.getPainterData()]);
  },
  methods: {
    getPainterData() {
      return new Promise((resolve) => {
        var vm = this;
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toapaintersendstartdate",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
                orderid: this.query.orderid,
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              var data = response.data.data;
              Object.assign(this.input, data[0]);
            }
            resolve();
          });
      });
    },
    toapaintertransaction() {
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toapaintertransaction",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: { orderid: this.query.orderid },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
            } else if (response.data.responsecode == 200) {
              resolve();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
            }
          });
      });
    },
    async confirmData() {
      if (!this.saveloading) {
        var vm = this;
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          vm.saveloading = true;

          await this.toapaintertransaction();
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toapaintersendstartdate",
              {
                ...this.input,
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
                orderid: this.query.orderid,
              },
              {
                headers: { AUTHORIZATION: "Bearer xxx xxx" },
              }
            )
            .then(async (response) => {
              vm.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                await this.$swal.fire({
                  icon: "success",
                  text: "สำเร็จ",
                });
                if (this.$store.state.redirect) {
                  this.query.view = this.$store.state.redirect;
                } else {
                  if (this.query.apptype == "line") {
                    await this.$liff.closeWindow();
                  } else if (this.query.apptype == "facebook") {
                    this.$store.dispatch("messengerClose");
                  }
                }
              } else {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
              }
            });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.v-date-picker-table table {
  margin-top: 0px;
}
</style>